// src/hooks/useChat.ts
import { useMemo } from 'react';
import { useCreateChatClient } from 'stream-chat-react';
import { ChatStore } from '../api/ChatStore';
import { useAppCookies } from '@app/providers/AppCookieProvider';
import { useUserProfileViewCreator } from '@viewCreators/UserProfileViewCreator';

const API_KEY = import.meta.env.VITE_APP_STREAM_API_KEY!;

export function useChat() {
  const cookies = useAppCookies();
  const userId = cookies.profile?.id ? Number(cookies.profile.id) : 0;
  const { data: user } = useUserProfileViewCreator(userId);

  const avatarUrl = user?.avatarUrl || cookies.profile?.picture || '';
  const displayName = user?.name || cookies.profile?.name || '';

  // Always define the token provider — do not gate with an early return
  const tokenOrProvider = useMemo(() => {
    return async () => {
      const userId = Number(cookies.profile?.id);
      const store = new ChatStore();
      const { result: token } = await store.CreateChatToken(userId);
      return token;
    };
  }, [cookies.profile?.id]);

  const streamOptions = {
    timeout: 10000,
  };

  // App only mounts this with a profile cookie, and unmounts it when the cookie goes, which disconnects the client
  const client = useCreateChatClient({
    apiKey: API_KEY,
    tokenOrProvider,
    userData: {
      id: String(cookies.profile.id),
      name: displayName,
      image: avatarUrl,
    },
    options: streamOptions,
  });

  return { client };
}
